export default "__VITE_ASSET__BiB4qblO__"